import { createContext } from 'react';

import { type TableMode } from '../../constants';

type ItemsContextType = {
  itemsMode?: TableMode;
  setItemsMode?: (mode: TableMode) => void;
};

const ItemsContext = createContext<ItemsContextType>({});

export default ItemsContext;
